import { createReducer, on } from '@ngrx/store';
import {
  readAgenda,
  readAgendaFailure,
  readAgendaSuccess,
  readEvents,
  readEventsFailure,
  readEventsSuccess,
} from './event.actions';
import { CalendarEventDto } from '@shared/dto';
import { logout } from '@auth/store/auth.actions';
import { State } from '@store/state.interface';

export const EVENT_FEATURE_KEY = 'events';

export interface EventState extends State<CalendarEventDto> {
  /**
   * The top-bar day agenda, kept apart from `data`. The two surfaces coexist (the top
   * bar is in the layout shell, so it is up while the dashboard is open) and load
   * different ranges — sharing one slot made each one truncate the other's events.
   */
  agenda: CalendarEventDto[] | null;
}

export const initialState: EventState = {
  data: null,
  detail: null,
  agenda: null,
  loading: false,
  error: null,
};

export const eventReducer = createReducer(
  initialState,
  on(readEvents, (state) => ({ ...state, loading: true, error: null })),
  on(readEventsSuccess, (state, { data }) => ({ ...state, data, loading: false })),
  on(readEventsFailure, (state, { error }) => ({ ...state, loading: false, error })),
  // The agenda load is a background refresh behind a popover: it deliberately leaves
  // `loading`/`error` alone so it never drives the dashboard calendar's spinner.
  on(readAgendaSuccess, (state, { data }) => ({ ...state, agenda: data })),
  on(logout, () => initialState),
);
